module.exports = __webpack_public_path__ + "img/avaliacao.c389b7a9.png";